import React, { useState } from 'react';
import Grid from '@material-ui/core/Grid';
import {
    withTheme,
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions
} from '@material-ui/core';
import ConfirmOrDenyBooking from '../atom/ConfirmOrDenyBooking';

const ConfirmOrDenyBookingModal = ({ id, hash, status, theme, showModal, MODAL_TYPE }) => {
    const [pageType, setPageType] = useState('notknown');
    const [state, setState] = useState(status);
    return (
        <Dialog
            aria-labelledby="guest-new-modal"
            open
            onClose={() => showModal(MODAL_TYPE.NONE)}
            maxWidth="sm"
        >
            <DialogTitle>Reservation #{id}</DialogTitle>
            <DialogContent>
                <Grid container spacing={1} justifyContent="center" alignItems="center">
                    {pageType === 'notknown' ? (
                        <Grid item xs={12}>
                            <p>The current state is {status}.</p>
                            {state === 'unconfirmed' && <p>What would you like to do?</p>}
                        </Grid>
                    ) : (
                        <ConfirmOrDenyBooking pageType={pageType} id={id} hash={hash} />
                    )}
                </Grid>
            </DialogContent>
            <DialogActions>
                <Button
                    onClick={() => {
                        showModal(MODAL_TYPE.NONE);
                    }}
                >
                    Close
                </Button>
                {state === 'unconfirmed' && (
                    <>
                        <Button
                            style={{ color: theme.palette.error.main }}
                            onClick={() => {
                                setPageType('deny');
                                setState('denied');
                            }}
                        >
                            Deny
                        </Button>

                        <Button
                            style={{ color: theme.palette.primary.main }}
                            onClick={() => {
                                setPageType('confirm');
                                setState('confirmed');
                            }}
                        >
                            Confirm
                        </Button>
                    </>
                )}
            </DialogActions>
        </Dialog>
    );
};

export default withTheme(ConfirmOrDenyBookingModal);
